import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'underscore';

import SelectField from '../../../../_common/platform/tsx/SelectField';

import { getValidRelations } from '../../../platform/tsx/filtering/FilterUtilities';

import { ATTRIBUTE_TYPES } from '../../../platform/ts/ConfigurationConstants';

import { RELATIONS } from '../../../platform/tsx/filtering/Constants';

import { AttributeSelectionType } from '../../../platform/tsx/filtering/Interfaces';

export default class FilterRelationSelect extends React.Component<
    {
        value: string;
        defaultAttributeType: string;
        selectionType?: AttributeSelectionType; //'single' by default.

        addSpecialOptions?: {
            attributeType: string;
        };

        onChange(value: string): void;
    },
    {}
> {
    constructor(props) {
        super(props);

        // this.state = {
        // }
    }

    handleValueChange = (value: string) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    addOption(options: any[], value: string, relationValues: string[], title?: string) {
        if (_.indexOf(relationValues, value) === -1) {
            options.push(
                <option key={value} value={value}>
                    {title || value}
                </option>
            );
        }
    }

    render() {
        const relationValues = getValidRelations(this.props.defaultAttributeType, this.props.selectionType);

        let options: React.JSX.Element[];
        let selectedValue = this.props.value;

        if (relationValues != null) {
            options = _.map(relationValues, (value) => {
                return (
                    <option key={value} value={value}>
                        {value}
                    </option>
                );
            });

            selectedValue = selectedValue || relationValues[0];
        }

        if (this.props.addSpecialOptions != null && this.props.defaultAttributeType != null) {
            const { attributeType } = this.props.addSpecialOptions;

            if (attributeType != null && attributeType !== ATTRIBUTE_TYPES.ANYTYPE) {
                if (options == null) {
                    options = [];
                }

                if (attributeType !== ATTRIBUTE_TYPES.LOGICAL) {
                    if (attributeType !== ATTRIBUTE_TYPES.BOOLEAN) {
                        this.addOption(options, RELATIONS.IS_ONE_OF, relationValues);
                        this.addOption(options, RELATIONS.IS_NOT_ONE_OF, relationValues);
                        this.addOption(options, RELATIONS.IS_SUBNODE_OF, relationValues);
                        this.addOption(options, RELATIONS.IS_NOT_SUBNODE_OF, relationValues);
                    }

                    if (this.props.defaultAttributeType !== 'functionParameter') {
                        this.addOption(options, RELATIONS.IGNORE, relationValues, 'Ignore Global Filter');

                        selectedValue = selectedValue || RELATIONS.IGNORE;
                    }

                    this.addOption(options, RELATIONS.REQUIRE_VALUE, relationValues, 'Require Value');
                }
            } else if (this.props.defaultAttributeType === 'functionParameter') {
                this.addOption(options, RELATIONS.REQUIRE_VALUE, relationValues, 'Require Value');
            }
        }

        return (
            <SelectField value={selectedValue} onChange={this.handleValueChange}>
                {options}
            </SelectField>
        );
    }
}
